module.exports = __webpack_public_path__ + "static/media/view2.22646df6.jpg";